import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Drawer, Form, Select, Divider } from 'antd';

import { ItemTypes, ItemTypeTitles } from './utils';

import { AddButton } from '@common/components';
import CreateBackgroundIdentificationTemplate from './item-forms/create-background-identification-template';
import CreateLicenseTemplate from './item-forms/create-license-template';
import CreateCertificationTemplate from './item-forms/create-certification-template';
import CreateAssessmentTemplate from './item-forms/create-assessment-template';
import CreateHealthDocumentTemplate from './item-forms/create-health-document-template';
import CreateOtherDocumentTemplate from './item-forms/create-other-document-template';
import CreateImmigrationTemplate from './item-forms/create-immigration-template';
import FormActions from './form-actions';

function AddItemForm({ dismiss, worksListTemplateId, form }) {
  const [currentType, setCurrentType] = useState();

  function renderForm(type) {
    switch (type) {
      case 'background_identification':
        return (
          <CreateBackgroundIdentificationTemplate
            form={form}
            worksListTemplateId={worksListTemplateId}
            dismiss={dismiss}
          />
        );
      case 'immigration':
        return (
          <CreateImmigrationTemplate
            form={form}
            worksListTemplateId={worksListTemplateId}
            dismiss={dismiss}
          />
        );
      case 'license':
        return (
          <CreateLicenseTemplate
            form={form}
            worksListTemplateId={worksListTemplateId}
            dismiss={dismiss}
          />
        );
      case 'certification':
        return (
          <CreateCertificationTemplate
            form={form}
            worksListTemplateId={worksListTemplateId}
            dismiss={dismiss}
          />
        );
      case 'assessment':
        return (
          <CreateAssessmentTemplate
            form={form}
            worksListTemplateId={worksListTemplateId}
            dismiss={dismiss}
          />
        );
      case 'health_document':
        return (
          <CreateHealthDocumentTemplate
            form={form}
            worksListTemplateId={worksListTemplateId}
            dismiss={dismiss}
          />
        );
      case 'other_document':
        return (
          <CreateOtherDocumentTemplate
            form={form}
            worksListTemplateId={worksListTemplateId}
            dismiss={dismiss}
          />
        );
    }
  }

  return (
    <React.Fragment>
      <Form layout="vertical">
        <Form.Item
          label="Please select a Compliance Item Type"
          name="todoItemType"
        >
          <Select size="large" onChange={setCurrentType} showSearch>
            {ItemTypes.map((type) => {
              return (
                <Select.Option key={type} value={type}>
                  {ItemTypeTitles[type]}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
      </Form>

      {currentType && (
        <React.Fragment>
          <Divider plain>New {ItemTypeTitles[currentType]} Item</Divider>
          {renderForm(currentType)}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

AddItemForm.propTypes = {
  worksListTemplateId: PropTypes.string.isRequired,
  dismiss: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
};

function AddItemTemplateModal(props) {
  const [form] = Form.useForm();
  const { visible, setVisible, worksListTemplateId } = props;

  if (!visible) return null;

  return (
    <Drawer
      title="Add Compliance Item"
      width={550}
      open={visible}
      onClose={() => setVisible(false)}
      footer={
        <FormActions
          onCancel={() => setVisible(false)}
          onSubmit={form.submit}
        />
      }
    >
      <AddItemForm
        form={form}
        worksListTemplateId={worksListTemplateId}
        dismiss={() => setVisible(false)}
      />
    </Drawer>
  );
}

AddItemTemplateModal.propTypes = {
  worksListTemplateId: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
};

export default function AddItemTemplate(props) {
  const [visible, setVisible] = useState(false);
  const { worksListTemplateId } = props;

  return (
    <>
      <AddButton onClick={() => setVisible(true)}>Compliance Item</AddButton>

      <AddItemTemplateModal
        worksListTemplateId={worksListTemplateId}
        visible={visible}
        setVisible={setVisible}
      />
    </>
  );
}

AddItemTemplate.propTypes = {
  worksListTemplateId: PropTypes.string.isRequired,
};
